import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=c510feae"
import script from "./Highlights.vue?vue&type=script&lang=ts"
export * from "./Highlights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c510feae')) {
      api.createRecord('c510feae', component.options)
    } else {
      api.reload('c510feae', component.options)
    }
    module.hot.accept("./Highlights.vue?vue&type=template&id=c510feae", function () {
      api.rerender('c510feae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/Highlights.vue"
export default component.exports